<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.INITIATION.SUBMIT_FORM"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION"
    :handler="() => $refs.modal.hide('from_close_operation_initiation')"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMATION_CANCELED"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    mainClass="fixed z-[53]"
    noInnerPadding
    noOverlay
    hideCloseButton
    @closed="
      ({ source }) => {
        source !== 'from_close_operation_initiation' &&
          $stores?.services?.state?.paymentInitiated &&
          $bus.emit($constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION);
      }
    "
  >
    <!-- Header avec dégradé -->
    <div
      :style="{
        background: `linear-gradient(135deg, ${service?.color}dd, ${service?.color}cc)`
      }"
      class="relative rounded-t-2xl overflow-hidden pb-8 pt-2 -mb-5 formContainer"
    >
      <!-- Ornement décoratif -->
      <div
        class="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"
      ></div>
      <div
        class="absolute bottom-0 left-0 w-32 h-32 bg-black/10 rounded-full translate-y-1/2 -translate-x-1/2"
      ></div>

      <div class="pb-10 px-6 pt-6 -mb-6 relative z-10">
        <div class="grid grid-cols-d5 items-center gap-4">
          <div class="col-span-4">
            <div class="text-white font-extrabold text-3xl tracking-tight">
              {{ service?.name }}
            </div>
            <div class="text-white/90 text-base font-medium mt-1">
              {{ operation?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-8 p-6 bg-white rounded-t-3xl relative z-2">
      <!-- Résumé de la transaction -->
      <!-- {{ $stores?.services?.state }} -->

      <div
        v-if="$stores?.services?.state?.paymentInitiated"
        class="flex flex-col items-center space-y-4 pb-16"
      >
        <div class="w-[60vw] h-[60vw]">
          <LottieComponent
            class="scale-150"
            :src="$constants.SERVICES.LOTTIES.PAYMENT_SUCCESS"
          />
        </div>
        <h2 class="text-2xl font-semibold text-green-600">Paiement initié</h2>
        <p class="text-gray-600">
          {{ 'La transaction a été démarrée avec succès.' }}
        </p>
        <div>
          <button
            class="w-full flex items-center justify-center gap-3 py-4 px-6 text-white font-bold text-lg rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group"
            :style="{
              background: `linear-gradient(135deg, ${service?.color}ee, ${service?.color}cc)`
            }"
            @click="() => $refs.modal.hide()"
          >
            <span class="relative z-10">Terminer</span>
          </button>
        </div>
      </div>

      <!-- DEFAULT -->
      <div
        v-else-if="$stores?.services?.state?.initiatingPayment"
        class="flex flex-col items-center space-y-4 pb-16 pt-12"
      >
        <div class="w-[30vw] h-[30vw]">
          <span class="loader"></span>
        </div>
        <h2 class="text-xl font-semibold">En cours</h2>
        <p class="text-gray-500">Initiation en cours...</p>
        <div>
          <button
            class="w-full flex items-center justify-center gap-3 py-4 px-6 text-white font-bold text-lg rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group"
            :style="{
              background: `linear-gradient(135deg, ${service?.color}ee, ${service?.color}cc)`
            }"
            @click="() => $refs.modal.hide()"
          >
            <span class="relative z-10">Retour</span>
          </button>
        </div>
      </div>
      <div
        class="bg-white rounded-3xl interraction-guard-watch"
        :class="{ shimmerContainer: fees?.loadingFees }"
        v-else-if="!$stores?.services?.state?.initiationError"
      >
        <div class="mb-6">
          <h3 class="text-xl font-bold mb-2" :style="{ color: service?.color }">
            Résumé de la transaction
          </h3>
          <p class="text-gray-600 text-sm">
            Vérifiez les informations avant de confirmer
          </p>
        </div>

        <!-- Timeline des opérations -->
        <div
          class="rounded-2xl p-4 mb-4"
          :style="{ backgroundColor: `${service?.color}15` }"
        >
          <h4
            class="font-bold mb-4 shimmerTarget"
            :style="{ color: service?.color }"
          >
            Déroulement de l'opération
          </h4>
          <div class="flex flex-col items-center">
            <div
              v-for="(step, index) in transactionSteps"
              :key="step.id"
              class="flex gap-4 pb-6 w-full relative"
              :class="{ 'pb-0': index === transactionSteps.length - 1 }"
            >
              <div class="flex-1 max-w-min">
                <div class="h-full flex justify-center">
                  <!-- Ligne de progression -->
                  <div
                    v-if="index < transactionSteps.length - 1"
                    class="absolute h-full border-l-2 left-6 top-12"
                    :style="{ borderColor: `${service?.color}40` }"
                  ></div>
                  <!-- Cercle de l'étape -->
                  <div
                    class="rounded-full w-12 h-12 p-3 shimmerTarget relative flex items-center justify-center transition-all duration-300 z-10"
                    :class="{
                      'scale-110': index === 0
                    }"
                    :style="{
                      backgroundColor: service?.color,
                      boxShadow: `0 10px 15px -3px ${service?.color}40, 0 4px 6px -2px ${service?.color}20`
                    }"
                  >
                    <!-- Icônes SVG intégrées -->
                    <svg
                      v-if="step.id === 'collect' || step.id === 'transfer'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'validate'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'deposit' || step.id === 'convert'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'request'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 14l-7 7m0 0l-7-7m7 7V3"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'process'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'receive'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="
                        step.id === 'purchase' || step.id === 'activate'
                      "
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'deliver'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      ></path>
                    </svg>
                    <svg
                      v-else-if="step.id === 'complete'"
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                    <!-- Icône par défaut -->
                    <svg
                      v-else
                      class="h-6 w-6 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="flex flex-col flex-1">
                <div
                  class="text-lg font-bold shimmerTarget"
                  :style="{ color: service?.color }"
                >
                  {{ step.title }}
                </div>
                <div class="mt-1 text-sm text-gray-600 shimmerTarget">
                  {{ step.description }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bonus Section -->
        <div
          class="rounded-2xl p-4 mb-4 bg-green-50 border border-green-200"
          v-if="fees.bonus > 0"
        >
          <div class="flex justify-between items-center">
            <span class="font-bold text-green-700 shimmerTarget"
              >Bonus offert</span
            >
            <span class="shimmerTarget text-xl font-bold text-green-700">
              {{ formatAmount(fees.bonus) }} CFA
            </span>
          </div>
        </div>

        <!-- Transaction Details -->
        <div class="space-y-3 mb-6">
          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
          >
            <span class="text-gray-600 shimmerTarget">Type d'opération</span>
            <span class="shimmerTarget font-medium text-gray-900 capitalize">{{
              getOperationType()
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.recipientAmount"
          >
            <span class="text-gray-600 shimmerTarget">Montant</span>
            <span class="shimmerTarget font-medium text-gray-900"
              >{{ formatAmount(transactionData.recipientAmount) }} CFA</span
            >
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="fees.fee > 0"
          >
            <span class="text-gray-600 shimmerTarget">Frais</span>
            <span class="shimmerTarget font-medium text-gray-900"
              >{{ formatAmount(fees.fee) }} CFA</span
            >
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.paymentMethod"
          >
            <span class="text-gray-600 shimmerTarget">Mode de paiement</span>
            <span class="shimmerTarget font-medium text-gray-900">{{
              transactionData.paymentMethod.name ||
              transactionData.paymentMethod
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.phoneNumber"
          >
            <span class="text-gray-600 shimmerTarget">Téléphone</span>
            <span class="shimmerTarget font-medium text-gray-900">{{
              transactionData.phoneNumber
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.email"
          >
            <span class="text-gray-600 shimmerTarget">Email</span>
            <span class="shimmerTarget font-medium text-gray-900">{{
              transactionData.email
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.cardType"
          >
            <span class="text-gray-600 shimmerTarget">Type de carte</span>
            <span class="shimmerTarget font-medium text-gray-900 capitalize">{{
              transactionData.cardType
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.subscriptionType"
          >
            <span class="text-gray-600 shimmerTarget">Type d'abonnement</span>
            <span class="shimmerTarget font-medium text-gray-900 capitalize">{{
              transactionData.subscriptionType
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.duration"
          >
            <span class="text-gray-600 shimmerTarget">Durée</span>
            <span class="shimmerTarget font-medium text-gray-900">{{
              transactionData.duration
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.cardCode"
          >
            <span class="text-gray-600 shimmerTarget">Code de la carte</span>
            <span class="shimmerTarget font-medium text-gray-900">{{
              transactionData.cardCode
            }}</span>
          </div>

          <div
            class="flex justify-between items-center py-2 border-b border-gray-100"
            v-if="transactionData.bookmakerIdToUse"
          >
            <span class="text-gray-600 shimmerTarget">ID bookmaker</span>
            <span class="shimmerTarget font-medium text-gray-900">
              <BookmakerAccountDetail
                :bookmaker="service.id"
                :bookmakerId="transactionData.bookmakerIdToUse"
              />
            </span>
          </div>
        </div>

        <!-- Total Amount -->
        <div
          class="rounded-2xl p-4 mb-6 shimmerTarget"
          :style="{ backgroundColor: `${service?.color}15` }"
        >
          <div class="flex justify-between items-center">
            <span class="font-bold" :style="{ color: service?.color }"
              >Total à payer</span
            >
            <span class="text-2xl font-bold" :style="{ color: service?.color }">
              {{
                formatAmount(fees.srcAmount || transactionData.recipientAmount)
              }}
              CFA
            </span>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col shimmerTarget rounded-2xl gap-4">
          <button
            v-bus:EVENTS.SERVICES.INITIATION.CONFIRM.click
            :disabled="$stores?.services?.state?.initiatingPayment"
            class="w-full flex items-center justify-center gap-3 py-4 px-6 text-white font-bold text-lg rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            :style="{
              background: `linear-gradient(135deg, ${service?.color}ee, ${service?.color}cc)`
            }"
          >
            <div
              v-if="$stores?.services?.state?.initiatingPayment"
              class="flex items-center justify-center gap-2 relative z-10"
            >
              <div
                class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
              ></div>
              <span>Traitement...</span>
            </div>
            <div
              v-else
              class="flex items-center justify-center gap-2 relative z-10"
            >
              <span>Continuer</span>
              <svg
                class="w-6 h-6 group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </div>
          </button>

          <button
            @click="() => $refs.modal.hide()"
            type="button"
            class="w-full py-4 px-6 font-semibold rounded-2xl border-2 transition-all duration-300 flex items-center justify-center gap-3 hover:bg-gray-50 active:scale-[0.98]"
            :style="{
              borderColor: service?.color,
              color: service?.color
            }"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.5"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>
            Retour
          </button>
        </div>
      </div>

      <div
        class="h-full min-h-[30vh] flex items-center justify-center bg-white"
        v-else
      >
        <div
          class="text-center rounded-2xl shadow-sm border border-gray-100 max-w-md"
        >
          <div class="flex items-center justify-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-10 w-10 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01M4.93 4.93l14.14 14.14M12 2a10 10 0 100 20 10 10 0 000-20z"
              />
            </svg>
          </div>
          <h2 class="text-lg font-semibold text-gray-800 mb-2">
            Échec survenu
          </h2>
          <p class="text-sm text-gray-600 leading-relaxed">
            {{ $stores?.services?.state?.initiationError }}
          </p>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ServiceSummaryDialog',
  data() {
    return {};
  },
  computed: {
    service() {
      return this.$stores.services?.state?.transactionInitiation?.service;
    },
    operation() {
      return this.$stores.services?.state?.transactionInitiation?.operation;
    },
    fees() {
      return this.$stores.services?.state?.transactionInitiationFees || {};
    },
    transactionData() {
      return this.$stores.services?.state?.transactionInitiation || {};
    },
    transactionSteps() {
      const steps = [];
      const serviceType = this.getServiceType();
      const operationType = this.getOperationType();

      const paymentMethodStep =
        this.transactionData.paymentMethod?.id == 'mobileMoney'
          ? [
              {
                id: 'collect',
                title: 'Paiement Mobile Money',
                description: `Nous envoyons une demande de paiement de ${this.formatAmount(
                  this.transactionData.recipientAmount
                )} CFA sur votre numéro ${this.transactionData.phoneNumber}`
              },
              {
                id: 'validate',
                title: 'Validation du paiement',
                description: 'Vous validez la demande de paiement'
              }
            ]
          : this.transactionData.paymentMethod?.id == 'wallet'
            ? [
                {
                  id: 'collect',
                  title: 'Paiement via le portefeuille',
                  description: `Nous prélèvons ${this.formatAmount(
                    this.transactionData.recipientAmount
                  )} CFA de votre portefeuille Kingrecharge`
                }
              ]
            : [{}];

      const recipientMethodStep =
        this.transactionData.recipientMethod?.id == 'mobileMoney'
          ? {
              id: 'transfer',
              title: 'Transfert Mobile Money',
              description: `Nous transférons ${this.formatAmount(
                this.transactionData.recipientAmount
              )} sur votre numéro Mobile Money ${
                this.transactionData.recipientPhoneNumber
              }`
            }
          : this.transactionData.recipientMethod?.id == 'wallet'
            ? {
                id: 'collect',
                title: 'Transfer sur portefeuille',
                description: `Nous déposons ${this.formatAmount(
                  this.transactionData.recipientAmount
                )} CFA sur votre portefeuille Kingrecharge`
              }
            : {};

      if (serviceType === 'bookmaker') {
        if (operationType === 'Recharge') {
          steps.push(
            ...paymentMethodStep,
            {
              id: 'deposit',
              title: 'Recharge sur votre compte',
              description: `Nous allons recharger le compte ${this.service.name} (ID: ${this.transactionData.bookmakerIdToUse})`
            },
            {
              id: 'complete',
              title: 'Opération terminée',
              description: `Votre compte ${this.service.name} sera rechargé`
            }
          );
        } else if (operationType === 'Retrait') {
          steps.push(
            {
              id: 'request',
              title: 'Demande de retrait',
              description: `Nous traitons votre demande de retrait de ${this.formatAmount(
                this.transactionData.recipientAmount
              )} CFA`
            },
            {
              id: 'process',
              title: 'Traitement Bookmaker',
              description: 'Validation de la demande par le bookmaker'
            },
            recipientMethodStep,
            {
              id: 'complete',
              title: 'Opération terminée',
              description: 'Vous pouvez disposer de vos fonds à votre guise'
            }
          );
        }
      } else if (serviceType === 'usdt') {
        if (operationType === 'Achat') {
          steps.push(
            ...paymentMethodStep,
            {
              id: 'transfer',
              title: 'Achat USDT',
              description: `Nous achetons des USDT`
            },
            {
              id: 'complete',
              title: 'Opération terminée',
              description: 'Votre adresse USDT sera rechargée'
            }
          );
        } else if (operationType === 'Vente') {
          steps.push(
            {
              id: 'receive',
              title: 'Réception USDT',
              description: 'Nous recevons les USDT sur votre adresse'
            },
            {
              id: 'validate',
              title: 'Validation USDT',
              description: 'Confirmation de la réception sur la blockchain'
            },
            {
              id: 'convert',
              title: 'Conversion CFA',
              description: `Nous convertissons en ${this.formatAmount(
                this.transactionData.recipientAmount
              )} CFA`
            },
            recipientMethodStep,
            {
              id: 'complete',
              title: 'Opération terminée',
              description: 'Vous pouvez disposer de vos fonds à votre guise'
            }
          );
        }
      } else if (serviceType === 'giftcard') {
        if (this.operation?.id === 'buy') {
          steps.push(
            ...paymentMethodStep,
            {
              id: 'purchase',
              title: 'Achat carte cadeau',
              description: `Nous procéder à l'achat de votre carte cadeau ${
                this.transactionData.cardType || ''
              }`
            },
            {
              id: 'complete',
              title: 'Opération terminée',
              description: 'Vous recevrez votre code par email/SMS'
            }
          );
        } else {
          steps.push(
            {
              id: 'receive',
              title: 'Réception carte cadeau',
              description: 'Nous recevons et validons votre code'
            },
            {
              id: 'validate',
              title: 'Validation',
              description: 'Confirmation du solde et validité'
            },
            recipientMethodStep,
            {
              id: 'complete',
              title: 'Opération terminée',
              description: 'Vous pouvez disposer de vos fonds'
            }
          );
        }
      } else if (serviceType === 'subscription') {
        steps.push(
          ...paymentMethodStep,
          {
            id: 'activate',
            title: 'Activation abonnement',
            description: `Nous activons votre abonnement ${
              this.transactionData.subscriptionType || ''
            }`
          },
          {
            id: 'complete',
            title: 'Opération terminée',
            description: 'Votre abonnement sera activé'
          }
        );
      }

      // Si aucune étape n'a été ajoutée, ajouter des étapes par défaut
      if (steps.length === 0) {
        steps.push(
          ...paymentMethodStep,
          {
            id: 'process',
            title: 'Traitement',
            description: 'Nous traitons votre transaction'
          },
          {
            id: 'complete',
            title: 'Opération terminée',
            description: 'Votre transaction sera complétée'
          }
        );
      }

      return steps;
    }
  },
  mounted() {},
  methods: {
    getServiceType() {
      if (
        this.service?.id === 'bookmaker' ||
        ['1xbet', 'betwinner', 'melbet', 'eightstarz', '1win'].includes(
          this.service?.id
        )
      ) {
        return 'bookmaker';
      } else if (this.service?.id === 'usdt') {
        return 'usdt';
      } else if (this.service?.id === 'giftCard') {
        return 'giftcard';
      } else if (this.service?.id === 'subscription') {
        return 'subscription';
      }
      return 'other';
    },

    getOperationType() {
      // Pour les cartes cadeaux, vérifier si c'est un achat ou une vente
      if (this.service?.id === 'giftCard') {
        return this.operation?.id === 'buy' ? 'Achat' : 'Vente';
      }

      // Pour l'USDT
      if (this.service?.id === 'usdt') {
        if (this.operation?.id === 'buy') return 'Achat';
        if (this.operation?.id === 'sell') return 'Vente';
      }

      // Pour les autres services
      if (this.operation?.id === 'fund' || this.operation?.id === 'buy')
        return 'Recharge';
      if (this.operation?.id === 'withdraw' || this.operation?.id === 'sell')
        return 'Retrait';
      if (this.service?.id === 'subscription') return 'Abonnement';
      return 'Transaction';
    },

    formatAmount(amount) {
      if (!amount) return '0';
      return new Intl.NumberFormat('fr-FR').format(amount);
    }
  }
});
</script>
